//SET ERROR STATE


export const setErrorState = (payload) => ({
    type : 'SET_ERROR_STATE',
    payload
});

export const setIsLoaded = (isLoaded) => ({
    type : 'SET_IS_LOADED',
    isLoaded
});




// WEBPACK FOOTER //
// ./src/Actions/errorHandler.js